var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables23 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "678.791px",
    height: "679.846px",
    viewBox: "0 0 678.791 679.846",
    enableBackground: "new 0 0 678.791 679.846",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.064,165.624C628.953,114.401,646.23,59.998,612.348,0 c5.941,0.486,11.887,0.931,17.836,1.417c67.57,51.445,60.373,123.829,4.999,209.72c74.864,97.144-35.606,228.88-107.384,228.432 c-78.936-0.48-74.548,56.663-98.369,86.463c-23.89,29.852-38.785,11.948-83.514,32.813c-44.713,20.887-13.871,53.057-76.502,85.839 C206.82,677.495,172.715,686.564,0,675.134c154.611-100.46,64.895-226.068,190.86-256.426 C413.242,365.107,398.867,48.587,582.064,165.624L582.064,165.624z M497.439,203.178c-27.326,17.413-53.514,43.418-66.36,70.833 l30.118,22.657c21.491-17.918,48.929-32.428,68.34-43.092L497.439,203.178L497.439,203.178z M448.44,308.588l-23.468-17.646 c-3.891,15.603-2.764,31.231,5.584,45.564C433.861,326.568,440.274,317.271,448.44,308.588z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables23, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-23.d3ff4d24.svg";
export { ForwardRef as ReactComponent };